module.exports = __webpack_public_path__ + "static/media/amarant-news-2.8f6e368a.png";